import React, { Fragment } from 'react'
import ActionButton from './ActionButton'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import EditSectionNameModal from './EditSectionNameModal'
import RemoveSectionModal from './RemoveSectionModal'
import SetExpirationModal from './SetExpirationModal'
import ArchiveSectionModal from './ArchiveSectionModal'

const ActionButtonSection = props => {
  return (
    <Fragment>
      <ActionButton>
        <EditSectionNameModal
          section={props.section}
          sectionName={props.sectionName}
        />
        <RemoveSectionModal
          section={props.section}
          sectionName={props.sectionName}
        />
        <SetExpirationModal section={props.section} />
        <ArchiveSectionModal
          sectionId={props.section}
          sectionName={props.sectionName}
        />
      </ActionButton>
    </Fragment>
  )
}

ActionButtonSection.propTypes = {
  section: PropTypes.string,
  sectionName: PropTypes.string,
  rowData: PropTypes.array,
}

const mapStateToProps = state => {
  return {
    rowData: state.sectionRowData,
  }
}

export default connect(mapStateToProps)(ActionButtonSection)
